import React, { useEffect, useState } from "react";
import CheckboxCustom from "../../../../features/CheckboxCustom";
import useFacility from "../../../../utils/hooks/useFacility";
import useNewsletterConfirmation from "../../NewsletterConfirmation/useNewsletterConfirmation";
import { RiMailStarLine } from "react-icons/ri";

interface IProps {
  email?: string;
}
const CheckBoxNewsletter: React.FC<IProps> = ({email}) => {
  const [form, setForm] = useState({ mail: "", name:"", lastName:"", checkbox1: false, checkbox2: false });
  const facilityIds = useFacility();
  const { sendInvite, alert } = useNewsletterConfirmation();
  useEffect(() => {
    if(form.checkbox1 === true && email){
    setTimeout(() => {
  
        sendInvite(facilityIds, email)
     
    }, 2000);
  }
  }, [email]);



  return (
    <React.Fragment>
  
    <div className="flex-start-center">
    <RiMailStarLine className="newsletter-icon" />
    <h3>Dołącz do newslettera</h3>
    </div>

        
        <CheckboxCustom
          value={form.checkbox1}
          setValue={(value) => setForm({ ...form, checkbox1: value })}
          label="
          Zaznaczając to pole, wyrażam zgodę na otrzymywanie newslettera drogą mailową. Rozumiem i akceptuję warunki <a target='_blank' href='https://panel.eaktywni.pl/img/1228/klauzula_informacyjna_new.pdf'>polityki prywatności</a> dotyczące przetwarzania moich danych osobowych.
  "
        />

    </React.Fragment>
  );
};

export default CheckBoxNewsletter;
